import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/ResearchPageComponents/ResearchPageSection/ResearchPageSection.tsx");
